// extracted by mini-css-extract-plugin
module.exports = {"card":"LogoCard_card__nlN0k","imageContainer":"LogoCard_imageContainer__7DTFP"};